import React, { Component } from "react";
import { SortableButton } from '../sortable-button-component/sortableButton';
import { PaginationButtons } from '../pagination-component/pagination';



class Table extends Component {

	render () {
		let header_th = [];
		if ( typeof(this.props.header) !== 'undefined' ) {
			for ( let head_key in this.props.header ) {
				let head_column = this.props.header[head_key];
				let sortable_button = null;
				if ( typeof(head_column.sortButton) !== 'undefined' && head_column.sortButton ) {
					sortable_button = (<SortableButton 
						column={head_key}
                        currentSortable={this.props.currentOrder || {}}
                        multiSortable={false}
                        callbackFunction={this.props.changeOrderCallback || null}
					 />);
				}
				header_th.push(<th key={"table_data_header_th_" + head_key}>
					{sortable_button} {head_column.label || ''}
				</th>);
			}
		}
		let head_columns_count = header_th.length;
		let t_head = null;
		if ( head_columns_count ) {
			t_head = (<thead>
                    	<tr className="table-warning">
                    		{header_th}
                    	</tr>
                    </thead>);
		}

		let body_tr = [];
		let body_content = this.props.body || null;
		if ( body_content && typeof(body_content) === 'object' && typeof(this.props.rows) !== 'undefined' && Object.keys(this.props.rows).length ) {
			for ( let row_key in this.props.rows ) {
				let row = this.props.rows[row_key];
				let body_tr_td = [];
				for ( let number_of_column in body_content ) {
					let column_value = null;
					if ( typeof(body_content[number_of_column]) === 'function' ) {
						column_value = body_content[number_of_column](row);
					}
					body_tr_td.push(<td key={"table_data_body_tr_" + row_key + "_td_" + number_of_column}>
						{column_value}
					</td>);
				}

				if ( body_tr_td.length ) {
					body_tr.push(<tr key={"table_data_body_tr_" + row_key}>
						{body_tr_td}
					</tr>);
				}
			}
		} else {
			body_tr.push(<tr key={"table_data_body_tr_empty"}>
				<td colSpan={head_columns_count}>
					{this.props.emptyRowsMessage || ''}
				</td>
			</tr>);
		}
		let t_body = null;
		if ( head_columns_count ) {
			t_body = (<tbody>{body_tr}</tbody>);
		}
		

		let pagination = null;
		if ( this.props.page && this.props.allPages > 1 ) {
			pagination = (<div className="pt-3 os-text-center">
							<PaginationButtons 
								activePage={this.props.page} 
		                        allPages={this.props.allPages}
		                        callbackFunction={this.props.changePageCallback || null}
							/>
						</div>);
		}


		return (<>
			<div className="table-responsive">
				<table className="table table-bordered table-hover">
                    {t_head}
                    {t_body}
                </table>
			</div>
			{pagination}
		</>);
	}

}


export default Table;